<script>
import MyReviewMixin from '@/mixins/my_review'

export default {
  name: 'MyReviewTable',
  mixins: [MyReviewMixin],
  props: {
    reviewTable: { required: true }
  },
  data: function() {
    return {
      tableData: [],
      reviewRecordId: null
    }
  },
  computed: {
    dataQuery() {
      let conditions = this.reviewTable.conditions || {}
      conditions.personId = { type: 'Int', required: true }
      return this.buildGraphqlQuery(
        this.reviewTable.lookup,
        [
          {
            nodes: true,
            fields: this.reviewTable.fields
          }
        ],
        {
          conditions: conditions,
          filters: this.reviewTable.filters,
          params: this.reviewTable.params,
          searchName: 'reviewTableLoadQuery'
        }
      )[0]
    },
    tableFields() {
      let tableFields = []
      for (let field of this.reviewTable.fields) {
        if (typeof field.show == 'undefined' || field.show) {
          tableFields.push(
            this.buildResultField({
              ...(typeof field == 'string' ? { name: field } : field),
              order: true
            })
          )
        }
      }
      tableFields.push({
        key: 'edit',
        label: 'Review / Update'
      })
      return tableFields
    },
    markReviewedMutation() {
      return this.buildGraphqlMutation(
        'createReview',
        [
          {
            name: 'input',
            params: [
              {
                name: 'review',
                params: [
                  { field: 'reviewItem', required: true },
                  { field: 'reviewRecord', required: true },
                  { field: 'personId', type: 'Int', required: true }
                ]
              }
            ]
          }
        ],
        [
          {
            join: 'review',
            fields: ['nodeId']
          }
        ],
        {
          mutationName: 'markReviewMutation'
        }
      )
    }
  },
  methods: {
    loadData() {
      this.dataLoaded = false
      this.graphqlAllPages(this.dataQuery, { personId: this.myPersonId }).then(
        data => {
          this.$set(this, 'tableData', data[this.reviewTable.lookup].nodes)
        }
      )
    },
    reviewRecord(data) {
      this.reviewRecordId =
        data[this.reviewTable.fields.find(field => field.required).field]
      this.$bvModal.show(`review-modal-${this.reviewTable.id}`)
    },
    sortResults(context) {
      let formatter = this.tableFields.find(fld => fld.key == context.sortBy)
        .formatter
      this.tableData.sort((v1, v2) => {
        let val1 = (formatter(v1[context.sortBy], context.sortBy, v1) || '')
          .toString()
          .toUpperCase()
        let val2 = (formatter(v2[context.sortBy], context.sortBy, v2) || '')
          .toString()
          .toUpperCase()
        if (val1 < val2) {
          return context.sortDesc ? 1 : -1
        }
        if (val1 > val2) {
          return context.sortDesc ? -1 : 1
        }
        return 0
      })
    },
    reviewFormSubmit(data) {
      this.buildRequestMessage(data)
      if (this.requestMessage != '') {
        this.requestSubject = this.reviewTable.submitSubject.interpolate(data)
        this.graphql(this.sendEmailMutation, {
          to: process.env.VUE_APP_SUPPORT_EMAIL,
          subject: this.requestSubject,
          message: this.requestMessage
        }).then(() => {
          this.markAsReviewed(true)
        })
      } else {
        this.requestMessage = 'No changes requested, record marked as reviewed.'
        this.markAsReviewed(true)
      }
    },
    markAsReviewed(fromSubmit) {
      this.graphql(this.markReviewedMutation, {
        reviewItem: this.reviewTable.reviewItem,
        reviewRecord: this.reviewRecordId.toString(),
        personId: this.myPersonId
      }).then(() => {
        this.$bvModal.hide(`review-modal-${this.reviewTable.id}`)
        if (fromSubmit) {
          this.$bvModal.show(`review-modal-${this.reviewTable.id}-submitted`)
        }
        this.loadData()
      })
    }
  },
  mounted() {
    //console.log(this.dataQuery)
    //console.log(this.sendEmailMutation)
    this.loadData()
  }
}
</script>

<template>
  <div>
    <ResultsTable
      :results="tableData"
      :fields="tableFields"
      :localSorting="false"
      @editRecord="reviewRecord"
      @sortingChanged="sortResults"
    />
    <b-modal
      :id="`review-modal-${reviewTable.id}`"
      :title="reviewTable.reviewTitle || 'Review'"
      size="xl"
      scrollable
      centered
      hide-footer
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
    >
      <GraphQLFormEdit
        :formType="reviewTable.formType"
        :recordId="reviewRecordId"
        :submitTriggerInsteadOfSave="true"
        @submitForm="reviewFormSubmit"
        ref="formEdit"
      />
      <b-row>
        <b-col class="text-center">
          <br />
          <b-button class="button" @click="markAsReviewed()">
            No Changes Requested - Mark as Reviewed
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      :id="`review-modal-${reviewTable.id}-submitted`"
      :title="reviewTable.submittedTitle"
      size="xl"
      scrollable
      centered
      hide-footer
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
    >
      <b-row v-if="requestSubject != ''">
        <b-col cols="2" class="font-weight-bold">Subject:</b-col>
        <b-col>{{ requestSubject }}</b-col>
      </b-row>
      <b-row>
        <b-col v-if="requestSubject != ''" cols="2" class="font-weight-bold">
          Message:
        </b-col>
        <b-col>
          <pre>{{ requestMessage }}</pre>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
